import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import infoGraphic from 'enrollment/assets/DecisionIQFindOutHowImage.png';
import { PsButtonTuner, PsAccordionTuner, PsAccordionChild } from 'stencilSetup';
import { OrbitDrawer } from 'enrollment/components/Shared/OrbitDrawer';

import './InfoDrawer.css';

// declare const bootstrap: any;
interface InfoDrawerProps {
  triggerLabel?: string;
}

export const InfoDrawer = ({ triggerLabel }: InfoDrawerProps) => {
  const { t } = useTranslation('pages.decisionIQ');
  const renderHtml = (key: string) => {
    const htmlContent = t(key);
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  };

  const [infoDrawerOpen, setInfoDrawerOpen] = useState(false);

  const eventInfoDrawer = () => {
    setInfoDrawerOpen(true);
  };

  const closeInfoDrawer = () => {
    setInfoDrawerOpen(false);
  };

  return (
    <>
      <PsButtonTuner
        data-testid="info-drawer-trigger"
        buttonId="decisionIQInfoDrawer"
        label={triggerLabel || t('how_deciq_assist')}
        showUnderline
        onClick={eventInfoDrawer}
        level="tertiary"
        extraClass="ml-n3_5"
      />
      <OrbitDrawer
        data-testid="info-orbit-drawer"
        drawerId="decisionIQInfoDrawer"
        heading={t('info_drawer.title')}
        dialogLarge={true}
        isOpen={infoDrawerOpen}
        handleClose={closeInfoDrawer}
      >
        <>
          <p className="mb-4 mb-md-5">{t('info_drawer.we_work')}</p>
          <img
            src={infoGraphic}
            alt="Decision IQ"
            aria-hidden="true"
            role="presentation"
            className="mb-4 mb-md-5"
          />
          <p className="mt-0 mt-md-5">{t('info_drawer.we_do_this')}</p>
          <p className="semiBold mt-5 mt-md-5 mb-2_5">
            {renderHtml('info_drawer.is_my_information_secure')}
          </p>
          <p className="mb-5">{t('info_drawer.your_privacy')}</p>

          <h2 className="h3 mobile mb-3">{t('info_drawer.faq')}</h2>

          <PsAccordionTuner accordionId="infoDrawerQuestions" flush={true}>
            <PsAccordionChild parent="infoDrawerQuestions" name="info">
              <span slot="accordion-trigger">
                {renderHtml('info_drawer.questions.best_match')}
              </span>
              <span slot="accordion-content">
                {renderHtml('info_drawer.questions.best_match_answer')}
              </span>
            </PsAccordionChild>
            <PsAccordionChild parent="infoDrawerQuestions" name="infoTwo">
              <span slot="accordion-trigger">
                {renderHtml('info_drawer.questions.costs_vary')}
              </span>
              <span slot="accordion-content">
                <p>{renderHtml('info_drawer.questions.costs_vary_answer')}</p>
              </span>
            </PsAccordionChild>
            <PsAccordionChild parent="infoDrawerQuestions" name="infoThree">
              <span slot="accordion-trigger">
                {renderHtml('info_drawer.questions.plan_designs')}
              </span>
              <span slot="accordion-content">
                <p>{renderHtml('info_drawer.questions.plan_designs_answer')}</p>
              </span>
            </PsAccordionChild>
            <PsAccordionChild parent="infoDrawerQuestions" name="infoFour">
              <span slot="accordion-trigger">
                {renderHtml('info_drawer.questions.men_or_women')}
              </span>
              <span slot="accordion-content">
                {' '}
                <p>{renderHtml('info_drawer.questions.men_or_women_answer')}</p>
              </span>
            </PsAccordionChild>
            <PsAccordionChild parent="infoDrawerQuestions" name="infoFive">
              <span slot="accordion-trigger">
                {renderHtml('info_drawer.questions.children_or_adults')}
              </span>
              <span slot="accordion-content">
                <p>
                  {renderHtml(
                    'info_drawer.questions.children_or_adults_answer'
                  )}
                </p>
              </span>
            </PsAccordionChild>
            <PsAccordionChild parent="infoDrawerQuestions" name="infoSix">
              <span slot="accordion-trigger">
                {renderHtml('info_drawer.questions.personalize_information')}
              </span>
              <span slot="accordion-content">
                <p>
                  {renderHtml(
                    'info_drawer.questions.personalize_information_answer'
                  )}
                </p>
              </span>
            </PsAccordionChild>
            <PsAccordionChild parent="infoDrawerQuestions" name="infoSeven">
              <span slot="accordion-trigger">
                {renderHtml('info_drawer.questions.estimates_calculated')}
              </span>
              <span slot="accordion-content">
                <p>
                  {renderHtml(
                    'info_drawer.questions.estimates_calculated_answer'
                  )}
                </p>
              </span>
            </PsAccordionChild>
          </PsAccordionTuner>
        </>
      </OrbitDrawer>
    </>
  );
};
